import { createContext, useContext } from 'react';

export const TableFocusContext = createContext(null);

export const useTableFocus = () => {
  const context = useContext(TableFocusContext);
  if (!context) throw new Error('useTableFocus must be used within TableFocusProvider');
  return context;
};